import { Button, TextField } from "@material-ui/core";
import axios from "axios";
import React, { useState } from "react";
import config from "react-global-configuration";
import Backdrop from "../../Backdrop/Backdrop";
import Modal from "../../Modal/Modal";

const SalvarModelo = (props) => {
	const [modalOpen, SetModalOpen] = useState(false);
	const [formData, SetFormData] = useState(false);
	const [saving, SetSaving] = useState(false);
	const [modelSaved, SetModelSaved] = useState(false);
	const [messageForm, SetMessageForm] = useState("");

	const saveModel = () => {
		if (formData.name) {
			SetSaving(true);
			SetModelSaved(false);

			axios
				.post(config.get("url_api") + "orcamento/salvar-modelo", {
					consultor_id: props.infoUsers.negocio.consultor.id,
					nome: formData.name,
					json: {
						consultor: props.infoUsers.negocio.consultor,
						pessoa: props.infoUsers.negocio.pessoa,
						resumo: props.orcamentoResumo,
						produtos: props.orcamentoProdutos,
						metodosPagamentos: props.paymentMethodsSelecteds,
						extras: props.orcamentoExtras,
						compraProgramada: props.compraProgramada,
						mercadoPagoSenJuros: props.mercadoPagoSenJuros,
					},
				})
				.then(function (response) {
					SetSaving(false);
					SetModelSaved(true);
					SetMessageForm("Modelo salvo!");
				})
				.catch(function (error) {
					SetMessageForm("Erro ao salvar modelo. " + error.message);
					SetSaving(false);
					SetModelSaved(true);
				});
		}
	};
	return (
		<React.Fragment>
			{modalOpen && (
				<Backdrop>
					<Modal
						title="Salvar modelo"
						onCancel={() => {
							SetModalOpen(false);
						}}
						saving={saving}
						onConfirm={!modelSaved ? () => saveModel() : null}
						onConfirmLabel="Salvar modelo"
						size={"sm"}
					>
						{modelSaved && <h4 className="p-1 text-ceter">{messageForm}</h4>}
						{!modelSaved && (
							<TextField
								margin="dense"
								id="modelName"
								name="modelName"
								label="Nome"
								autoComplete="off"
								fullWidth
								autoFocus
								value={formData && formData.name ? formData.name : ""}
								onChange={(e) => SetFormData({ name: e.target.value })}
								inputProps={{
									maxLength: 100,
								}}
							/>
						)}
					</Modal>
				</Backdrop>
			)}
			<Button
				onClick={() => SetModalOpen(true)}
				variant="contained"
				color="default"
				fullWidth
				disabled={saving || props.disabled}
			>
				{!saving ? "Salvar Modelo" : "Salvando..."}
			</Button>
		</React.Fragment>
	);
};

export default SalvarModelo;
